// Environment configuration
const environment = {
  // Backend API Configuration
  // Local
   //API_BASE_URL: 'https://localhost:44340/api',
   // DEV
  API_BASE_URL: 'https://aesoppricingdevapi.baryons.net/api',
   // UAT
   //API_BASE_URL: 'http://10.206.1.22:8080/api',
  // Staging
  //API_BASE_URL: 'https://aesoppricingstagapi.baryons.net/api',
  
  // API Configuration - More conservative for dev environment
  API_TIMEOUT: 30000, // 30 seconds timeout (reduced from 45)
  API_RETRY_ATTEMPTS: 2, // Reduced retry attempts
  API_RETRY_DELAY: 3000, // 3 seconds base delay (increased from 2)
};

export default environment; 